import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import './style.scss';

/**
 * Experimental-Design FullWidthImage component:
 */
export function FullWidthImage(props) {
  const image = (
    <Image
      src={props.image}
      alt='content-item'
      className={props.className}
      width='100%'
    />
  );
  if (props.caption) {
    return (
      <figure className='fullWidthImage'>
        {image}
        <figcaption>{props.caption}</figcaption>
      </figure>
    );
  } else {
    return image;
  }
}

FullWidthImage.propTypes = {
  /**
   * String repersenting type of component
   */
  type: PropTypes.string,
  /**
   * Repersenting requiered array of contents
   */
  content: PropTypes.array,
  /**
   * Url to the image.
   */
  image: PropTypes.string.isRequired,
  /**
   * String repersenting classname of the image
   */
  className: PropTypes.string,
  /** 
   * caption of the image
   */
  caption: PropTypes.string,
};

FullWidthImage.defaultProps = {
    type: 'FULL_WIDTH_IMAGE',
  };